export const formatearValorACeroCuandoEsNan = ( valor, decimales ) => {
    let valorARetornar = undefined;
    valorARetornar = valor !== undefined || valor !== null || isNaN( valor )? 0 : parseFloat(valor).toFixed(decimales)
    return valorARetornar
}
